import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { getAccountInfo } from './salesforce';
import './Login.css';
import logo from "./logo.png";

const LOG_URL = process.env.REACT_APP_CLIENT_LOG_URL;

const Login = () => {
  const { id } = useParams(); // Extract ID from URL
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    Name: '',
    emailAddress: '',
    dob: '',
    zipcode: '',
  });
  const [lang, setLang] = useState(1);
  const [initialData, setInitialData] = useState({});
  const [responseData, setResponseData] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchPatientData = async () => {
      console.log("Fetching patient data...");
      try {
        const response = await getAccountInfo(id);
        console.log("API response:", response); // Log the entire response

        if (!response || !response.data) {
          throw new Error("No data returned from API");
        }

        const { Name, PersonEmail, PersonMailingPostalCode, Date_of_Birth__c } = response.data;

        setFormData((prevFormData) => ({
          ...prevFormData,
          Name: Name || '',
        }));

        setResponseData(response.data);
        localStorage.setItem('userName', Name);
        setInitialData({
          Name: Name || '',
          emailAddress: PersonEmail || '',
          zipcode: PersonMailingPostalCode || '',
          dob: Date_of_Birth__c || ''
        });
      } catch (error) {
        console.error("Error fetching patient data:", error);
      }
    };

    if (id) fetchPatientData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: name === 'emailAddress' ? value.toLowerCase() : value,
    }));
  };

  const handleLanguageChange = (e) => {
    const language = e.target.value;
   setLang(language);
  };
  const validateForm = () => {
    let isValid = true;
    let errors = {};

    // Simple validation checks
    if (!formData.emailAddress) {
      isValid = false;
      errors.emailAddress = 'Email address is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.emailAddress)) {
      isValid = false;
      errors.emailAddress = 'Email address is invalid';
    }

    if (!formData.zipcode) {
      isValid = false;
      errors.zipcode = 'Zipcode is required';
    } else if (!/^\d{5}$/.test(formData.zipcode)) {
      isValid = false;
      errors.zipcode = 'Zipcode is invalid';
    }
    if (!formData.dob) { // Validate DOB is provided
      isValid = false;
      errors.dob = 'Date of birth is required';
    } // You can add more validation for DOB format if needed

    setErrors(errors);
    return isValid;
  };

  const fetchIpAddress = async () => {
    try {
      const response = await axios.get('https://api.ipify.org?format=json');
      return response.data.ip;
    } catch (error) {
      console.error('Error fetching IP address:', error);
      return null;
    }
  };

  const logUserLogin = async (formData, loginSuccessful) => {
    const ipAddress = await fetchIpAddress();
    const message = loginSuccessful
      ? `User logged in - ${formData?.Name}`
      : `Failed to login - ${formData?.Name}`;
    axios.post(LOG_URL, {
      message: message,
      username: formData?.Name,
      patient_id: id,
      ipAddress: ipAddress
    })
    .then(response => {
      console.log(`Login log recorded: ${formData?.Name}`, response.data);
    })
    .catch(error => {
      console.error(`Error logging in: ${formData?.Name}`, error);
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      let loginSuccessful = true;
      let changedFields = [];
      
      // Check only email, zipcode, and dob
      ['emailAddress', 'zipcode', 'dob'].forEach((key) => {
        if (formData[key] !== initialData[key]) {
          changedFields.push(key);
        }
      });

      if (changedFields.length > 0) {
        loginSuccessful = false;
        alert(`Please check your credentials`);
      } else {
        navigate(`/User/${id}`, { state: { auth: true,lang:lang, userData: responseData } });
      }
      logUserLogin(formData, loginSuccessful); // Call logUserLogin function here
    } else {
      console.log('Form is invalid');
    }
  };

  return (
    <div className='loginPage'>
      <form onSubmit={handleSubmit} className="form-container">
        <div className='imageContainer'>
          <img src={logo} alt="Logo" />
        </div>
        <div className="form-group">
          <label className="label">Patient Name:</label>
          <input
            type="text"
            name="patientName"
            value={formData?.Name}
            readOnly
            className="input"
          />
        </div>
        <div className="form-group">
          <label className="label">Email Address:</label>
          <input
            type="email"
            name="emailAddress"
            value={formData.emailAddress}
            onChange={handleChange}
            className="input"
          />
          {errors.emailAddress && <p className="error-message">{errors.emailAddress}</p>}
        </div>

        <div className="form-group">
          <label className="label">Zipcode:</label>
          <input
            type="text"
            name="zipcode"
            value={formData.zipcode}
            onChange={handleChange}
            className="input"
          />
          {errors.zipcode && <p className="error-message">{errors.zipcode}</p>}
        </div>
        <div className="form-group">
          <label className="label">Date of Birth:</label>
          <input
            type="date" // Use "date" input type for DOB
            name="dob"
            value={formData.dob}
            onChange={handleChange}
            className="input"
          />
          {errors.dob && <p className="error-message">{errors.dob}</p>}
        </div>
        <div className="form-group">
          <label className="label">Language:</label>
          <select onChange={handleLanguageChange} className="input">
            <option value='1'>English</option>
            <option value="2">Spanish</option>
          </select>
        </div>
        <button type="submit" className="submit-button">Submit</button>
      </form>
    </div>
  );
};

export default Login;
